import { render, staticRenderFns } from "./RelatorioTaxaOscilacaoRiscos.vue?vue&type=template&id=48d35d69"
import script from "./RelatorioTaxaOscilacaoRiscos.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaOscilacaoRiscos.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaOscilacaoRiscos.vue?vue&type=style&index=0&id=48d35d69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports